module.exports = __webpack_public_path__ + "img/headRight2.a159a5e4.png";